<template>
  <div id="pageTable">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <match-filters
                v-model="localFilters"
                :tournament-view="!!tournament && !!tournament._id"
                @search="$store.dispatch('matches/setInit', localFilters)"
              />
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn
                v-if="can('create', 'match')"
                small
                color="primary"
                @click="sendEmit('create')"
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-xs-center pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                class="elevation-1"
                item-key="_id"
                :loading="loading"
                :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="justify-center px-0 caption" style="min-width: 115px;">
                    <v-btn flat icon small color="primary" class="mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('view', {matchId: props.item._id, actId:props.item.actId})"
                      >visibility</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('edit', 'match', props.item) || (tournament && can('edit', 'tournament', tournament)) || (props.item.tournamentId && hasRole('tournaments',props.item.tournamentId))"
                      flat
                      icon
                      small
                      color="success"
                      class="mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', {matchId:props.item._id, actId:props.item.actId})"
                      >create</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="can('delete', 'match', props.item) || (tournament && can('edit', 'tournament', tournament)) || (props.item.tournamentId && hasRole('tournaments',props.item.tournamentId))"
                      flat
                      icon
                      small
                      color="error"
                      class="mx-0"
                    >
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('remove', {matchId:props.item._id, actId:props.item.actId})"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.finalized"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td style="min-width: 150px;">{{props.item.tournament}}</td>
                  <td>{{formatDate(props.item.date)}}</td>
                  <td>{{props.item.time}}</td>
                  <td>
                    <v-chip
                      :key="index + 100"
                      v-for="(judge, index)  in props.item.judges"
                      small
                      color="primary"
                      text-color="white"
                    >{{ judge }}</v-chip>
                  </td>
                  <td style="min-width: 150px;">{{props.item.location}}</td>
                  <td>
                    <template v-if="props.item.user">{{ props.item.user}}</template>
                    <template v-else>
                      <v-chip
                        :key="index + 100"
                        v-for="(team, index)  in props.item.teams"
                        small
                        color="primary"
                        text-color="white"
                      >{{ team }}</v-chip>
                    </template>
                  </td>
                  <td>{{props.item.act}}</td>
                  <td>{{formatDate(props.item.createdAt, true)}}</td>
                  <td>{{props.item.createdByName }}</td>
                  <td>{{formatDate(props.item.updatedAt, true)}}</td>
                  <td>{{props.item.updatedByName}}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat, timeFormat } from '../../../helpers/dateHelper'
import MatchFilters from './MatchFilters'

export default {
  name: 'MatchList',
  components: { MatchFilters },
  props: {
    tournament: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      search: '',
      pagination: {
        sortBy: 'createdAt',
        descending: true
      },
      localFilters: { finalized: false },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            align: 'center',
            value: ''
          },
          {
            text: this.$t('state'),
            align: 'center',
            value: 'active'
          },
          {
            text: this.$t('finalized'),
            align: 'center',
            value: 'finalized'
          },
          {
            text: this.$tc('tournament'),
            align: 'center',
            value: 'tournament'
          },
          {
            text: this.$t('date'),
            align: 'center',
            value: 'date'
          },
          {
            text: this.$t('time'),
            align: 'center',
            value: 'time'
          },
          {
            text: this.$t('judges'),
            align: 'center',
            value: 'judges'
          },
          {
            text: this.$t('location'),
            align: 'center',
            value: 'location'
          },
          {
            text: `${this.$tc('team', 2)} / ${this.$tc('user')}`,
            align: 'center',
            value: 'teams'
          },
          {
            text: `${this.$tc('act')}`,
            align: 'center',
            value: 'act'
          },
          {
            text: this.$t('createdAt'),
            align: 'center',
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            align: 'center',
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            align: 'center',
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            align: 'center',
            value: 'updatedBy'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.matches.loading,
      listMatches: state => state.matches.list,
      listTournaments: state => state.tournaments.list,
      listUser: state => state.users.listaUsers,
      listStadiums: state => state.stadiums.listStadiums,
      listTeams: state => state.teams.listTeams,
      listActs: state => state.acts.list
    }),
    formatList() {
      let formatedList = Array.from(this.listMatches)
      formatedList = formatedList.map(match => {
        let result = {
          ...match,
          judges: match.judgesName
            ? match.judgesName.map(item => item.name)
            : [],
          user: match.userName ? match.userName.name : '',
          teams: match.teamsName || [],
          location: match.locationName ? match.locationName.name : ''
        }
        result.teamsName = result.teams.join(', ')
        result.judgesName = result.judges.join(', ')

        return result
      })
      formatedList = this.filterArray(formatedList, this.search)

      return formatedList
    }
  },
  methods: {
    ...mapActions({}),
    getType(match) {
      if (match.type == 'user') return 'user'
      else if (match.type == 'tournament') {
        if (
          this.tournament &&
          (this.tournament.type == 'users' ||
            this.tournament.type == 'usersTeams')
        )
          return 'user'
      }
      return 'teams'
    },
    sendEmit(evento, id = null) {
      this.$emit(evento, id)
    }
  }
}
</script>

<style scoped>
.container {
  max-width: none;
}
</style>
